export const OTHER_REASON_CODE = 'OTHER';

export const WALLET_FAILURE_REASONS = [
  {
    code: 'DEP_001',
    label: 'Proof of Payment Missing',
    EN: "We didn't receive proof of your payment. Please upload your payment confirmation.",
    FR: "Nous n'avons pas recu de preuve de votre paiement. Veuillez telecharger votre confirmation de paiement.",
  },
  {
    code: 'DEP_002',
    label: 'Payment Details Mismatch',
    EN: "The payment details don't match our records. Please verify the amount and reference.",
    FR: 'Les details du paiement ne correspondent pas a nos enregistrements. Veuillez verifier le montant et la reference.',
  },
  {
    code: 'DEP_003',
    label: 'Sender Name Mismatch',
    EN: "The sender name doesn't match your account name. For security, we can only accept payments from your registered account.",
    FR: "Le nom de l'expediteur ne correspond pas au nom de votre compte. Pour des raisons de securite, nous n'acceptons que les paiements de votre compte enregistre.",
  },
  {
    code: 'DEP_004',
    label: 'Duplicate Transaction',
    EN: 'This transaction has already been processed. Please check your balance.',
    FR: 'Cette transaction a deja ete traitee. Veuillez verifier votre solde.',
  },
  {
    code: 'DEP_005',
    label: 'Fraudulent Activity Suspected',
    EN: 'This transaction has been flagged for additional security review. Our team will contact you within 24 hours.',
    FR: 'Cette transaction a ete signalee pour un examen de securite supplementaire. Notre equipe vous contactera dans les 24 heures.',
  },
  {
    code: 'DEP_006',
    label: 'Payment Method Not Supported',
    EN: 'This payment method is not currently supported. Please use an approved payment method.',
    FR: "Ce mode de paiement n'est actuellement pas pris en charge. Veuillez utiliser un mode de paiement approuve.",
  },
  {
    code: 'DEP_007',
    label: 'Expired Payment Reference',
    EN: 'This payment reference has expired. Please initiate a new deposit.',
    FR: 'Cette reference de paiement a expire. Veuillez initier un nouveau depot.',
  },
  {
    code: 'DEP_008',
    label: 'Invalid Payment Source',
    EN: 'We cannot accept payments from this source. Please use a bank account or payment method in your name.',
    FR: 'Nous ne pouvons pas accepter les paiements de cette source. Veuillez utiliser un compte bancaire ou un mode de paiement a votre nom.',
  },
  {
    code: 'DEP_009',
    label: 'Amount Below Minimum',
    EN: 'The deposit amount is below the minimum required (EUR 10 / USD 10 / 5,000 XAF).',
    FR: 'Le montant du depot est inferieur au minimum requis (10 EUR / 10 USD / 5 000 XAF).',
  },
  {
    code: 'DEP_010',
    label: 'KYC Verification Required',
    EN: 'Please complete your identity verification before making deposits.',
    FR: "Veuillez completer votre verification d'identite avant d'effectuer des depots.",
  },
  {
    code: 'DEP_011',
    label: 'Account Suspended',
    EN: 'Your account is currently suspended. Please contact support.',
    FR: 'Votre compte est actuellement suspendu. Veuillez contacter le support.',
  },
  {
    code: 'DEP_012',
    label: 'Interac Security Question Missing',
    EN: "You set a security question but didn't provide the question and answer. The transfer will expire in 30 days.",
    FR: "Vous avez defini une question de securite mais n'avez pas fourni la question et la reponse. Le virement expirera dans 30 jours.",
  },
  {
    code: 'DEP_013',
    label: 'Payment Confirmation Illegible',
    EN: 'The uploaded payment confirmation is not clear. Please upload a clearer image.',
    FR: "La confirmation de paiement telechargee n'est pas claire. Veuillez telecharger une image plus nette.",
  },
  {
    code: 'DEP_014',
    label: 'Currency Mismatch',
    EN: "The payment currency doesn't match the deposit request.",
    FR: 'La devise de paiement ne correspond pas a la demande de depot.',
  },
  {
    code: 'DEP_015',
    label: 'Bank Transfer Rejected',
    EN: 'Your bank rejected the transfer. Please contact your bank for details.',
    FR: 'Votre banque a rejete le virement. Veuillez contacter votre banque pour plus de details.',
  },
  {
    code: 'DEP_016',
    label: 'Operator Rejected Transfer',
    EN: 'Operator rejected transfer, please try again with another number',
    FR: "L'operateur a rejete le transfert, veuillez reessayer avec un autre numero.",
  },
];

export const WITHDRAWAL_FAILURE_REASONS = [
  {
    code: 'WTH_001',
    label: 'Proof of Withdrawal Request Missing',
    EN: "We couldn't verify your withdrawal request details. Please provide the requested confirmation.",
    FR: "Nous n'avons pas pu verifier les details de votre demande de retrait. Veuillez fournir la confirmation demandee.",
  },
  {
    code: 'WTH_002',
    label: 'Withdrawal Details Mismatch',
    EN: "The withdrawal details don't match our records. Please verify the amount and destination details.",
    FR: 'Les details du retrait ne correspondent pas a nos enregistrements. Veuillez verifier le montant et les details de destination.',
  },
  {
    code: 'WTH_003',
    label: 'Beneficiary Name Mismatch',
    EN: "The beneficiary name doesn't match your verified account details.",
    FR: 'Le nom du beneficiaire ne correspond pas aux details verifies de votre compte.',
  },
  {
    code: 'WTH_004',
    label: 'Duplicate Withdrawal Request',
    EN: 'This withdrawal request appears to be a duplicate. Please check your transaction history.',
    FR: 'Cette demande de retrait semble etre un doublon. Veuillez verifier votre historique de transactions.',
  },
  {
    code: 'WTH_005',
    label: 'Fraudulent Activity Suspected',
    EN: 'This withdrawal has been flagged for additional security review. Our team will contact you within 24 hours.',
    FR: 'Ce retrait a ete signale pour un examen de securite supplementaire. Notre equipe vous contactera dans les 24 heures.',
  },
  {
    code: 'WTH_006',
    label: 'Withdrawal Method Not Supported',
    EN: 'This withdrawal method is not currently supported. Please use an approved withdrawal method.',
    FR: "Ce mode de retrait n'est actuellement pas pris en charge. Veuillez utiliser un mode de retrait approuve.",
  },
  {
    code: 'WTH_007',
    label: 'Withdrawal Request Expired',
    EN: 'This withdrawal request has expired. Please submit a new withdrawal request.',
    FR: 'Cette demande de retrait a expire. Veuillez soumettre une nouvelle demande de retrait.',
  },
  {
    code: 'WTH_008',
    label: 'Invalid Destination Account',
    EN: 'We cannot process this withdrawal to the provided destination account. Please update your payout details.',
    FR: 'Nous ne pouvons pas traiter ce retrait vers le compte de destination fourni. Veuillez mettre a jour vos details de paiement.',
  },
  {
    code: 'WTH_009',
    label: 'Amount Below Minimum',
    EN: 'The withdrawal amount is below the minimum allowed threshold.',
    FR: 'Le montant du retrait est inferieur au seuil minimum autorise.',
  },
  {
    code: 'WTH_010',
    label: 'KYC Verification Required',
    EN: 'Please complete your identity verification before making withdrawals.',
    FR: "Veuillez completer votre verification d'identite avant d'effectuer des retraits.",
  },
  {
    code: 'WTH_011',
    label: 'Account Suspended',
    EN: 'Your account is currently suspended. Please contact support.',
    FR: 'Votre compte est actuellement suspendu. Veuillez contacter le support.',
  },
  {
    code: 'WTH_012',
    label: 'Security Verification Missing',
    EN: 'Required security verification is missing. Please complete the security step and try again.',
    FR: 'La verification de securite requise est manquante. Veuillez completer cette etape et reessayer.',
  },
  {
    code: 'WTH_013',
    label: 'Withdrawal Documentation Illegible',
    EN: 'The submitted withdrawal documentation is not clear. Please upload a clearer document.',
    FR: 'La documentation de retrait soumise n est pas claire. Veuillez telecharger un document plus net.',
  },
  {
    code: 'WTH_014',
    label: 'Currency Mismatch',
    EN: "The withdrawal currency doesn't match the selected payout account.",
    FR: 'La devise du retrait ne correspond pas au compte de paiement selectionne.',
  },
  {
    code: 'WTH_015',
    label: 'Bank Transfer Rejected',
    EN: 'Your bank rejected the withdrawal transfer. Please contact your bank for details.',
    FR: 'Votre banque a rejete le virement de retrait. Veuillez contacter votre banque pour plus de details.',
  },
  {
    code: 'WTH_016',
    label: 'Operator Rejected Transfer',
    EN: 'Operator rejected transfer, please try again with another number',
    FR: "L'operateur a rejete le transfert, veuillez reessayer avec un autre numero.",
  },
];

export const KYC_REJECTION_REASONS = [
  {
    code: 'KYC_000',
    label: 'Minor (under 18)',
    EN: 'You are a minor. KYC is available only to users aged 18 and above.',
    FR: "Vous etes mineur. Le processus KYC est reserve aux utilisateurs ages de 18 ans et plus.",
  },
  {
    code: 'KYC_001',
    label: 'Unreadable identity document',
    EN: 'Your identity document is unreadable. Please upload a clearer copy.',
    FR: "Votre piece d'identite est illisible. Veuillez telecharger une copie plus claire.",
  },
  {
    code: 'KYC_002',
    label: 'Document details mismatch',
    EN: 'The details on your identity document do not match your profile information.',
    FR: "Les details de votre piece d'identite ne correspondent pas aux informations de votre profil.",
  },
  {
    code: 'KYC_003',
    label: 'Document expired',
    EN: 'Your identity document is expired. Please provide a valid, unexpired document.',
    FR: "Votre piece d'identite est expiree. Veuillez fournir une piece valide et non expiree.",
  },
  {
    code: 'KYC_004',
    label: 'Not a valid Government ID',
    EN: 'The document you submitted is not an official government ID that we can accept to verify your identity.',
    FR: "Le document que vous avez soumis n'est pas une pièce d'identité officielle émise par le gouvernement que nous pouvons accepter pour vérifier votre identité.",
  }, {
    code: 'KYC_005',
    label: 'Document not supported',
    EN: 'This type of document cannot be verified by our team, please submit a passeport or valid national identity card',
    FR: "Ce type de document ne peut être vérifié par notre équipe. Veuillez soumettre un passeport ou une carte d'identité nationale valide.",
  },
  // The agreed dashboard list. The wording is the handover's own, in both
  // languages, rather than prose invented here — short for a message body, so
  // an admin can still expand it in the form before sending.
  //
  // "Other" is not in here: the picker renders OTHER_REASON_CODE itself, and a
  // second one would not open the custom-message fields.
  {
    code: 'KYC_006',
    label: 'Blurry or unreadable ID photo',
    EN: 'Blurry or unreadable ID photo',
    FR: 'Photo de la pièce d’identité floue ou illisible',
  },
  {
    code: 'KYC_007',
    label: 'Expired identity document',
    EN: 'Expired identity document',
    FR: 'Document d’identité expiré',
  },
  {
    code: 'KYC_008',
    label: 'Unsupported document type',
    EN: 'Unsupported document type',
    FR: 'Type de document non pris en charge',
  },
  {
    code: 'KYC_009',
    label: 'Document photo cropped',
    EN: 'Document photo cropped',
    FR: 'Photo du document recadrée ou tronquée',
  },
  {
    code: 'KYC_010',
    label: 'Selfie does not match ID',
    EN: 'Selfie does not match ID',
    FR: 'Le selfie ne correspond pas à la pièce d’identité',
  },
  {
    code: 'KYC_011',
    label: 'Selfie too dark or blurry',
    EN: 'Selfie too dark or blurry',
    FR: 'Selfie trop sombre ou flou',
  },
  {
    code: 'KYC_012',
    label: 'Personal details do not match ID',
    EN: 'Personal details do not match ID',
    FR: 'Les informations personnelles ne correspondent pas à la pièce d’identité',
  },
  {
    code: 'KYC_013',
    label: 'Minimum age requirement not met',
    EN: 'Minimum age requirement not met',
    FR: 'Âge minimum requis non respecté',
  },
  {
    code: 'KYC_014',
    label: 'Identity linked to another account',
    EN: 'Identity linked to another account',
    FR: 'Identité déjà liée à un autre compte',
  },
  {
    code: 'KYC_015',
    label: 'Invalid proof of address',
    EN: 'Invalid proof of address',
    FR: 'Justificatif de domicile invalide',
  },
  {
    code: 'KYC_016',
    label: 'Additional compliance review',
    EN: 'Additional compliance review',
    FR: 'Vérification de conformité supplémentaire requise',
  },
  {
    code: 'KYC_017',
    label: 'Verification interrupted; reset completed',
    EN: 'Verification interrupted; reset completed',
    FR: 'Vérification interrompue ; réinitialisation effectuée',
  },
  {
    code: 'KYC_018',
    label: 'Verification reset completed',
    EN: 'Verification reset completed',
    FR: 'Réinitialisation de la vérification effectuée',
  },
];

const parseReasonMessages = messages => {
  if (!messages) return {};
  if (typeof messages === 'string') {
    try {
      return JSON.parse(messages);
    } catch (error) {
      return {};
    }
  }
  if (typeof messages === 'object') return messages;
  return {};
};

export const resolveReasonSelection = ({code, messages, registry}) => {
  const parsedMessages = parseReasonMessages(messages);
  const matchingReason = registry.find(item => item.code === code);
  const hasCustomMessages =
    Boolean(parsedMessages?.EN?.trim?.()) || Boolean(parsedMessages?.FR?.trim?.());

  if (matchingReason) {
    return {
      selectedCode: matchingReason.code,
      messageEN: parsedMessages?.EN || matchingReason.EN,
      messageFR: parsedMessages?.FR || matchingReason.FR,
      isOther: false,
    };
  }

  return {
    selectedCode:
      code && code.trim().length > 0
        ? OTHER_REASON_CODE
        : hasCustomMessages
        ? OTHER_REASON_CODE
        : undefined,
    messageEN: parsedMessages?.EN || '',
    messageFR: parsedMessages?.FR || '',
    isOther:
      (code && code.trim().length > 0) || hasCustomMessages ? true : false,
  };
};

export const buildReasonPayload = ({
  selectedCode,
  customMessageEN,
  customMessageFR,
  registry,
}) => {
  if (!selectedCode) return null;

  if (selectedCode === OTHER_REASON_CODE) {
    return {
      code: OTHER_REASON_CODE,
      messages: {
        EN: customMessageEN?.trim() || '',
        FR: customMessageFR?.trim() || '',
      },
    };
  }

  const matchingReason = registry.find(item => item.code === selectedCode);
  if (!matchingReason) return null;

  return {
    code: matchingReason.code,
    messages: {
      EN: customMessageEN?.trim() || matchingReason.EN,
      FR: customMessageFR?.trim() || matchingReason.FR,
    },
  };
};
